module.exports = __webpack_public_path__ + "static/media/FAMU Logo.b4382790.png";